import { InvoiceCheckoutItemModel } from "../../models/invoice/invoice-checkout-item-model";
import { InvoiceCheckoutModel } from "../../models/invoice/invoice-checkout-model";

export const newmapInvoiceData = (source: any, payId: number): InvoiceCheckoutModel => {
  
  const grossAmount: number = source.length>0
  ?source.taxableAmount + source.taxAmount - source.discountAmount
  :source.taxableAmount + source.taxAmount - source.discountAmount 
   + source.paymentGatewayCharges + source.courierCharges + source.handlingCharges + source.packingCharges;

  const mappedInvoiceItems: InvoiceCheckoutItemModel[] =
  source.orderDetails
    .filter((item: any) => item.pendingQuantity !== 0) 
    .map((item: any) => ({
      orderDetailID: item.orderDetailID,
      invoicedQuantity: item.pendingQuantity,
      totalAmount: Math.round(
        item.unitPrice * item.pendingQuantity +
          (item.unitPrice * item.pendingQuantity * item.gst) / 100
      ),
    }));

  return {
    orderID: source.orderID,
    posID: source.posID,
    taxableAmount: source.taxableAmount,
    taxAmount: source.taxAmount,
    discountAmount: source.discountAmount,
    paymentGatewayCharges: source.paymentGatewayCharges,
    grossAmount: Math.round(grossAmount),
    paymentModeID: payId,
    orderInvoiceDetail: mappedInvoiceItems
  };
}
